// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2klZ0","upload":"Small_upload__1W31v","imageWrap":"Small_imageWrap__39-mV","removeBtn":"Small_removeBtn__Jke2z"};